import { render, staticRenderFns } from "./ProductHistory.vue?vue&type=template&id=6a1ecb43&scoped=true"
import script from "./ProductHistory.vue?vue&type=script&lang=js"
export * from "./ProductHistory.vue?vue&type=script&lang=js"
import style0 from "./ProductHistory.vue?vue&type=style&index=0&id=6a1ecb43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ecb43",
  null
  
)

export default component.exports